module.exports = __webpack_public_path__ + "static/media/sending.efc1fb56.svg";